module.exports = __webpack_public_path__ + "assets/stripes-98ac57014423837135cba4ce41775d5f.png";